<div class="row d-flex justify-content-center align-items-center" >
  <div class="col-3 col-md-3 mb-2 mt-2" *ngFor="let partner of partners">
    <img [src]="baseUrl + partner.imageUrl" title="{{ partner.name }}" class="img-fluid" alt="{{ partner.name }}" />
  </div>
</div>
